import {z} from 'zod';

import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';

const BaseTeamFormSchema = z.object({
  name: z.string(),
  branches: z.array(z.string()),
  deputies: z.array(z.string()),
  leadId: z.string().nullable(),
  assignmentStrategy: z.enum(['assign_to_lead', 'least_recently_assigned']),
  active: z.boolean(),
  timeToAcceptAssignment: z.number().int().min(5).nullable(),
  maximumEscalations: z.number().int().nullable(),
});

export const TeamFormSchema = BaseTeamFormSchema.superRefine((values, context) => {
  const hasTimeToAcceptAssignment = isNotNil(values.timeToAcceptAssignment);
  const hasMaximumEscalations = isNotNil(values.maximumEscalations);

  if (hasMaximumEscalations && !hasTimeToAcceptAssignment) {
    context.addIssue({
      code: z.ZodIssueCode.custom,
      message: i18n.t('errors.field_is_required'),
      path: ['timeToAcceptAssignment'],
    });
  }

  if (hasTimeToAcceptAssignment && !hasMaximumEscalations) {
    context.addIssue({
      code: z.ZodIssueCode.custom,
      message: i18n.t('errors.field_is_required'),
      path: ['maximumEscalations'],
    });
  }
});

export type TeamFormValues = z.infer<typeof TeamFormSchema>;
